import { Styles, generateClasses } from 'netline-ui';

export const offlineInfoClasses = generateClasses('OfflineInfo', [
  'root',
  'errorHeader',
  'errorInfo',
  'backBtn',
] as const);

const styles: Styles = ({ theme: { palette, colors } }) => ({
  [`&.${offlineInfoClasses.root}`]: {
    backgroundColor: colors.grey[100],
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  [`.${offlineInfoClasses.errorHeader}`]: {
    marginTop: 30,
    color: palette.text.secondary,
    fontSize: 16,
    fontWeight: 500,
  },
  [`.${offlineInfoClasses.errorInfo}`]: {
    marginTop: 20,
    marginBottom: 20,
    color: palette.text.secondary,
    fontSize: 14,
  },
});

export default styles;
